import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '@roomex/rx-components';
import { ConfirmationRoom } from '@rx-applications/clientsite/shared/utils';
import { CleanupHtmlPipe } from './../../pipes/cleanup-html/cleanup-html.pipe';
import { SafeHtmlPipe } from './../../pipes/safe-html/safe-html.pipe';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-room-details-modal',
  templateUrl: './room-details-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalContentComponent, CleanupHtmlPipe, SafeHtmlPipe]
})
export class RoomDetailsModalComponent {
  @Input() selectedRoom!: ConfirmationRoom;

  constructor(public activeModal: NgbActiveModal) {}
}
